import { useEffect, useRef, useState ,lazy} from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { SETSELECTEDCATEGORY } from "../../redux/features/categoryList";
import { scrollToElementWithOffset } from "../../utils/scrollToElementWithOffset";
// import MobileMenuModal from "../Modal/MobileMenuModal";
import MobileMenuModal from "../Modal/MobileMenuModal";
import SideBarSkelton from "../Sidebar/SideBarSkelton";
import useSearchItem from "../../hooks/useSearchItem";
import { useMenuItemScroll } from "../../hooks/useMenuItemScroll";
const MobileMenu = () => {
  // const { store } = useSelector((store: any) => store);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {handleItemScroll}=useMenuItemScroll()
  const [isInfo, setIsInfo] = useState(false);
  const { handleSearchClear } = useSearchItem();

  const loading = false;
  const isOnline = navigator.onLine;
  // @@ gho to viola
  const goToViolation = (id: string) => {
    scrollToElementWithOffset(id);
    return;
  };

  const {
    categoryData: { selectedCategory },
    store: { allCategory },
  }: any = useSelector((state: any) => state);

  const listRef = useRef<any>(null);

  // useEffect(() => {
  //   // console.log(' window.innerWidth', window.innerWidth)
  //   if (selectedCategory && listRef.current &&  window.innerWidth  < 767) {
  //     // console.log('selectedCategory',selectedCategory)
  //     let category = `mobile-${selectedCategory}-mobile`
  //     const element = document.getElementById(category);
  //     if (element) {
  //       element.scrollIntoView({
  //         behavior: 'smooth',
  //         block: 'nearest',
  //         inline: 'center', // This ensures the element is centered horizontally.
  //       });
  //     }
  //   }
  // }, [selectedCategory]);

  const hasMountedRef = useRef(false);

  useEffect(() => {
    if (!hasMountedRef.current) {
      hasMountedRef.current = true;
      return;
    }
    if (selectedCategory && listRef.current && window.innerWidth < 767) {
      let category = `mobile-${selectedCategory}-mobile`;
      const element = document.getElementById(category);
      if (element) {
        element.scrollIntoView({
          behavior: "smooth",
          block: "nearest",
          inline: "center",
        });
      }
    }
  }, [selectedCategory]);

  // @@end this is for capture position sticky

  const onHandleChangeCategory = (slug: string) => {
    handleSearchClear();
    dispatch(SETSELECTEDCATEGORY(slug));
    setTimeout(() => {
      // goToViolation(slug);
      handleItemScroll(slug)
    }, 1);
    navigate(`?slug=${slug}`);
  };

  return (
    // This map is for main menu at mobile page

    <>
      {/* <div  className="bg-white sticky top-0 md:hidden block z-[9] mb-2"> */}
      <div className="bg-white sticky top-0 z-50 md:hidden block shadow-sm flex items-center gap-4">
        <button onClick={() => setIsInfo(true)}>
          <svg
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            className="text-[#34558b]"
          >
            <title>List</title>
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M1 3h3v3H1V3Zm6 0h16v3H7V3Zm0 7h16v3H7v-3Zm16 7H7v3h16v-3ZM4 10H1v3h3v-3Zm-3 7h3v3H1v-3Z"
              fill="currentColor"
            ></path>
          </svg>
        </button>
        <ul className="flex overflow-x-auto no-scrollbar whitespace-nowrap py-2 px-2 mob-menu-list">
          {/* <ul className="flex  scroll-hidden overflow-x-auto py-2"> */}
          {loading ? (
            <SideBarSkelton />
          ) : (
            allCategory?.map((value: any, index: any) => {
              return (
                <li
                  id={`mobile-${value?.slug}-mobile`}
                  ref={listRef}
                  className={`mob-menu-item ${
                    value?.slug == selectedCategory ? "active" : ""
                  }`}
                  onClick={() => onHandleChangeCategory(value?.slug)}
                  key={index}
                >
                  {/* {value?.slug} */}
                  <button type="button" className=" navBtn">
                    {value?.name}
                  </button>
                </li>
              );
            })
          )}
        </ul>
        <div
          data-baseweb="tab-highlight"
          aria-hidden="true"
          role="presentation"
          className="m6 ag l1 m7 m8 lx mb mc dl"
        ></div>
      </div>
      {/* {!isOnline && <NoInternet isOnline={isOnline} />} */}
      <MobileMenuModal isInfo={isInfo} setIsInfo={setIsInfo} />
    </>
  );
};

export default MobileMenu;
